<template>
  <div class="logout-view-container">
    <h1 class="page-title-container">Abmeldung</h1>
    <div class="view-container">
      <Popup @close="$router.push('/')">
        <p>Du wurdest erfolgreich abgemeldet!</p>
      </Popup>
    </div>
  </div>
</template>

<script>
import firebase from "firebase/app";
import Popup from "@/components/Popup.vue";

export default {
  name: "LogoutView",
  components: { Popup },
  mounted() {
    firebase.auth().signOut();
  },
};
</script>

<style lang="scss" scoped></style>
